import { useCallback, useEffect, useState } from 'react';
import { SITE } from '../data/site';

const META_COLOR = { light: '#E7E7F6', dark: '#0A0A1C' };

// The initial theme is applied by the inline script in public/index.html (before first paint).
let current = document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
const listeners = new Set();

function applyTheme(theme) {
    current = theme;
    document.documentElement.setAttribute('data-theme', theme);
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', META_COLOR[theme]);
    try { localStorage.setItem(SITE.storage.theme, theme); } catch {}
    listeners.forEach((l) => l(theme));
}

// Shared across every toggle on the page (header on desktop, footer on phones).
export function useTheme() {
    const [theme, setTheme] = useState(current);

    useEffect(() => {
        listeners.add(setTheme);
        setTheme(current);
        return () => { listeners.delete(setTheme); };
    }, []);

    const toggle = useCallback(() => applyTheme(current === 'dark' ? 'light' : 'dark'), []);

    return { theme, toggle };
}
